// assets/countdown-timer.js
// <countdown-timer data-end="2026-11-15T23:59:00Z"> com filhos [data-unit="days|hours|minutes"].
// Ao expirar, recebe o atributo data-expired (o CSS decide o que mostrar).

class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.end)) return;
    this.#tick();
    this.interval = setInterval(() => this.#tick(), 15000);
    // O carrinho re-renderiza por morph: o elemento continua o mesmo, mas os números voltam
    // para "–". Recalcula na hora quando isso acontece (só se houver "–", para não entrar em loop).
    this.observer = new MutationObserver(() => {
      if ([...this.querySelectorAll('[data-unit]')].some((el) => el.textContent.trim() === '–')) this.#tick();
    });
    this.observer.observe(this, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    this.observer?.disconnect();
  }

  #tick() {
    const diff = this.end - Date.now();
    if (diff <= 0) {
      this.setAttribute('data-expired', '');
      this.closest('[data-countdown-scope]')?.setAttribute('data-expired', '');
      clearInterval(this.interval);
      this.#set({ days: 0, hours: 0, minutes: 0 });
      return;
    }
    const minutes = Math.floor(diff / 60000);
    this.#set({
      days: Math.floor(minutes / 1440),
      hours: Math.floor((minutes % 1440) / 60),
      minutes: minutes % 60,
    });
  }

  #set(values) {
    for (const el of this.querySelectorAll('[data-unit]')) {
      const value = values[el.dataset.unit] ?? 0;
      el.textContent = el.dataset.unit === 'days' ? String(value) : String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
